/**
 * Swedish public holidays (röda dagar / arbetsbefriade dagar) for calendar filtering.
 * Uses npm package swedish-holidays – no external API.
 */

import { getHolidays } from 'swedish-holidays';

/**
 * Returns a Set of YYYY-MM-DD dates that are Swedish public holidays (arbetsbefriade dagar) for the given year.
 * Use to filter out red days from calendar display or from "workdays only" views.
 */
export function getPublicHolidayDatesForYear(year: number): Set<string> {
  const holidays = getHolidays(year) as Array<{ date: Date; isPublicHoliday?: boolean }>;
  const set = new Set<string>();
  for (const h of holidays) {
    if (!h.isPublicHoliday) continue;
    const ymd = h.date instanceof Date ? h.date.toISOString().slice(0, 10) : String(h.date).slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(ymd)) set.add(ymd);
  }
  return set;
}
